import { onValue, ref } from "firebase/database";
import { db } from "../configs/firabse";

export const getFirebaseRealTimeDatabase = (entity: string, refresh: () => void) => {
  onValue(ref(db, `/${entity}/client_order`), () => {
    refresh();
  });
};

export const getRealTimeProducts = (entity: string, refresh: (products: any[]) => void) => {
  const unsubscribe = onValue(ref(db, `/entity/${entity}/products`), (snapshot: any) => {
    if (snapshot.exists()) {
      const productsObj = snapshot.val();
      const products = Object.keys(productsObj).map((key) => {
        const product = productsObj[key];
        return {
          ...product,
          id: key,
          quantity: product.availableStock,
        };
      });
      refresh(products);
    } else {
      refresh([]);
    }
  });
  return unsubscribe;
};

export const onQRCodeLogin = (entity: string, totem: string, deviceId: string, login: (clientId: string) => void) => {
  const unsubscribe = onValue(ref(db, `/${entity}/client_login/${totem}`), (snapshot: any) => {
    if (snapshot.val() && snapshot.val().device_id === deviceId) {
      login(snapshot.val());
    }
  });
  return unsubscribe;
};
